import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Router } from '@angular/router';

import { QuotationFactory, ShipmentFactory } from '@library/common/models';
import { QuotationDetailsService } from '@library/modules/api-services';
import { ShipmentService } from '@library/modules/shipment';
import { ShipmentDetailsService } from '@library/modules/shipment-details';
import { TemplateService } from '@library/modules/templates';

@Component({
   selector: 'shipment-select',
   templateUrl: './shipment.select.component.html',
   styleUrls: ['./shipment.select.component.scss']
})
export class ShipmentSelectComponent implements OnInit {

   public static HasQuote = false;

   hasQuote() { return ShipmentSelectComponent.HasQuote; }

   resume = !!sessionStorage.getItem( 'TempShipment' );

   from = new FormControl( 'blank' );
   template_id = new FormControl();
   hawb = new FormControl();
   mode = new FormControl( 'copy' );
   tempDescription = "";

   q_mode = new FormControl( 'copy' );
   q_number = new FormControl();


   loading = false;

   constructor(
      private router: Router,
      private shipment: ShipmentService,
      private details: ShipmentDetailsService,
      private quoteService: QuotationDetailsService,

      public templateService: TemplateService,
   ) { }

   ngOnInit() {
   }

   next(): void {
      this.loading = true;
      this.from.disable();

      switch ( this.from.value ) {
         case 'previous':
            this.hawb.disable();
            this.mode.disable();
            if ( !this.hawb.value ) {
               this.loading = false;
               return;
            }

            this.hawb.setValue( this.hawb.value.trim() );
            this.mode.setValue( this.mode.value === 'copy' ? null : this.mode.value );

            this.details.load( this.hawb.value ).subscribe( shipment => {
               if ( shipment ) {
                  this.shipment.shipment = ShipmentFactory.copy( shipment, this.mode.value );
                  this.router.navigate([ '/create/shipment/new' ]);
               }

               this.loading = false;
            });
            break;
         case 'p_quote':
            this.q_number.disable();
            this.q_mode.disable();
            if ( this.q_number.value == null ) {
               this.loading = false;
               return;
            }

            this.q_number.setValue( this.q_number.value.trim() );
            this.q_mode.setValue( this.q_mode.value === 'copy' ? null : this.q_mode.value );
            this.quoteService.load( this.q_number.value ).subscribe(( quote ) => {
               if ( quote ) {
                  this.shipment.shipment = ShipmentFactory.copy( QuotationFactory.toShip( quote ), this.q_mode.value );
                  this.router.navigate([ '/create/shipment/new' ]);
               }

               this.loading = false;
            });
            break;

         case 'template':
            this.template_id.disable();
            if ( !this.template_id.value ) {
               this.loading = false;
               return;
            }

            this.templateService.getTemplate( this.template_id.value ).subscribe( template => {
               if ( template ) {
                  this.shipment.shipment = template.data;
                  this.router.navigate([ '/create/shipment/new' ]);
               }

               this.loading = false;
            });
            break;

         case 'blank':
            this.shipment.reset();

         default:
            this.router.navigate([ '/create/shipment/new' ]);
      }
   }

   click(template){
      this.tempDescription = template.description ? template.description : "" ;
   }

   buttonDisable() {
      return (this.from.value === 'template' && !this.template_id.value) || (this.from.value === 'previous' && !this.hawb.value) || (this.hasQuote() && this.from.value === 'p_quote' && !this.q_number.value);
   }
}
